import React from 'react';
import { Helmet } from 'react-helmet';

import { helmet } from '../../utils/helmet';
import Header from './header/header.component';
import Footer from './footer/footer.component';
import GoTop from './go-top/go-top.component';

const AppLayout: React.FC = ({ children }) => {
  return (
    <>
      <Helmet {...helmet} />
      <Header />
      {children}
      <Footer />
      <GoTop />
    </>
  );
};

export default AppLayout;
